import React from "react";
import { dialog, Button, Progress, InfiniteScroll } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import NominationRequestPresenter from "./NominationRequestPresenter";
import { FloatingForm } from "../../../../components/common/Converter";
import ViewNominationList from "./ViewNomination/ViewNominationList";

class NominationList extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new NominationRequestPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      titles: [],
      isViewOpen: false,
      objTitle: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const titles = await findObjectUseCase().execute("recipient_log");
    this.setState({ titles });
  }

  getCollectionName() {
    return "nomination_list";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleViewData(object) {
    // this.navigateTo(`/form/${this.getCollectionName()}/${object.id}`);
    this.setState({ isViewOpen: true, objTitle: object.title });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, current, limit, loading } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div style={{ margin: "1rem 0" }}>
          <CardView style={{ borderRadius: 0 }}>
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
          </CardView>
        </div>
        <div className="overflow-auto">
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-block">
                  <h4 className="text-primary">Recognition List</h4>
                </div>
              </CardView>

              <Table
                // progress={count > objects.length}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectData={this.handleViewData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
          {this.state.isViewOpen && (
            <FloatingForm width="60rem">
              <CardView style={{ padding: 0 }}>
                <ViewNominationList objTitle={this.state.objTitle} />
                <hr />
                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                  <button
                    className="btn btn-light"
                    onClick={() => this.setState({ isViewOpen: false })}
                  >
                    Close
                  </button>
                  {/* <button
                  className="btn btn-primary"
                  // onClick={this.hanldeSubmit.bind(this)}
                  type="submit"
                >
                  Submit
                </button> */}
                </div>
              </CardView>
            </FloatingForm>
          )}
        </div>
      </>
    );
  }
}

export default withRouter(NominationList);
